import React from 'react';
import { FaThLarge, FaThList } from 'react-icons/fa';

export type MobileGridViewMode = 'grid' | 'card';

interface GridViewToggleProps {
  mode: MobileGridViewMode;
  onToggle: () => void;
}

const GridViewToggle = ({ mode, onToggle }: GridViewToggleProps) => {
  const isGrid = mode === 'grid';

  return (
    <button
      type="button"
      className="grid-view-toggle"
      onClick={onToggle}
      aria-label={isGrid ? 'Alternar para visualização em cards' : 'Alternar para visualização em grade'}
      title={isGrid ? 'Visualização em cards' : 'Visualização em grade'}
    >
      {isGrid ? <FaThList size={18} aria-hidden /> : <FaThLarge size={18} aria-hidden />}
    </button>
  );
};

export default GridViewToggle;
